import ShrinkOutlined from '@ant-design/icons/ShrinkOutlined'
import ModalComp from 'Components/common/Modal/Modal'
import HtmlRenderer from 'Utils/htmlRenederer.utils'
import './ResponseModal.less'

type ResponseModalPropsType = {
    visible: boolean
    responseIndex: number
    content: string | null
    onClose: () => void
}

export const ResponseModal = (props: ResponseModalPropsType) => {
    return (
        <ModalComp
            visible={props.visible}
            modalHeader={
                <div className={'modal-header'}>
                    Response <span>{props.responseIndex + 1}</span>
                </div>
            }
            modalFooter={<></>}
            onCancel={props.onClose}
            closeIcon={<ShrinkOutlined />}
            className="response-modal"
        >
            <HtmlRenderer htmlContent={props.content ?? ''} className="response-html-renderer" />
        </ModalComp>
    )
}
